import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { requireAuthentication } from './utils/authHelper';
import Root from 'root/Root';
import NotFoundPage from './components/not-found-page/NotFoundPage.js';
import PurchasesController from 'purchases/PurchasesController';
import FaqController from 'faq/FaqController';
import DocumentController from 'pdf/DocumentController';
import PurchaseDocumentController from 'purchases/PurchaseDocumentController';
import CardContainer from './card/CardContainer';
import LoginContainer from 'containers/auth/login/loginContainer';
import GetAppContainer from './auth/get-app/get-app.container';
import EmailRegistrationContainer from 'containers/auth/email-registration/EmailRegistration';
import CreatePassword from 'containers/auth/create-password/CreatePassword';
import PasswordUpdated from 'containers/auth/passwordUpdated/passwordUpdated';
import ForgotPasswordControllerMapper from 'auth/ForgotPasswordControllerMapper';
import OtpRegisterController from 'auth/OtpRegisterController';
import OtpTypeRegisterController from 'auth/OtpTypeRegisterController';
import OtpTypeForgotPasswordController from 'auth/OtpTypeForgotPasswordController';
import OtpForgotPasswordController from 'auth/OtpForgotPasswordController';
import CreateNewPasswordController from 'auth/CreateNewPasswordController';
import ResetPasswordController from 'auth/ResetPasswordController';
import PdfStatementController from "./pdf/DocumentPdfStatmentController";
import RegisterControllerMapper from "auth/registerControllerMapper";
import OtpLoginController from "./containers/auth/login/OtpLoginController";
import OtpTypeLoginController from "./containers/auth/login/OtpTypeLoginController";
import HtmlStatementController from "./pdf/DocumentHtmlStatmentController";
import EmailVerification from "./containers/auth/email-verification/email-verification";

export default (
  <Route>
    <Route path="/dl/email-verification" component={EmailVerification} name="getApp"/>
    <Route path="/get-app" component={GetAppContainer} name="getApp"/>
    <Route path="/login" component={LoginContainer} name="login"/>
    <Route path="/email-registration" component={EmailRegistrationContainer} name="emailRegistration"/>
    <Route path="/create-password" component={CreatePassword} name="createPassword"/>
    <Route path="/register" component={RegisterControllerMapper} name="register"/>
    <Route path="/forgot-password" component={ForgotPasswordControllerMapper} name="forgotPassword"/>
    <Route path="/reset-password" component={ResetPasswordController} name="resetPassword"/>
    <Route path="/register-otp-verify" component={OtpRegisterController} name="otpRegisterController"/>
    <Route path="/register-otp-type" component={OtpTypeRegisterController} name="otpTypeRegisterController"/>
    <Route path="/forgot-password-otp-type" component={OtpTypeForgotPasswordController} name="otpTypeForgotPasswordController"/>
    <Route path="/forgot-password-otp-verify" component={OtpForgotPasswordController} name="otpForgotPasswordController"/>
    <Route path="/create-new-password" component={CreateNewPasswordController} name="createNewPasswordController"/>
    <Route path="/login-otp-verify" component={OtpLoginController} name="otpLoginController"/>
    <Route path="/login-otp-type-verify" component={OtpTypeLoginController} name="otpTypeLoginController"/>
    <Route path="/password-updated" component={PasswordUpdated} name="passwordUpdated"/>
    <Route path="/document/:document" component={DocumentController} name="document"/>
    <Route path="/transactions-pdf/file-date/:fileDate" component={PdfStatementController} name="transaction-pdf"/>
    <Route path="/transactions-html/file-date/:fileDate" component={HtmlStatementController} name="transaction-html"/>
    <Route path="/purchase-document/:externalId" component={PurchaseDocumentController} name="purchaseDocumentController"/>

    <Route path="/" component={requireAuthentication(Root)}>

      <Route path="/installments">
        <IndexRoute component={PurchasesController} name="installments"/>
      </Route>

      <Route path="/card(/:activeTab)(/:subTab)" component={CardContainer} name="Card"/>

      <Route path="/faq" component={FaqController} name="FAQ"/>
    </Route>

    <Route path="*" component={NotFoundPage}/>
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js